<template>
    <div>
        <template v-if="true">
            <div
                v-for="(content, i) in contents"
                :key="i"
                class="mt-4">
                <component
                    :is="content.type"
                    :type="content.type"
                    :course-id="course.id"
                    :content="content"
                    :index="i"
                    :public-user="publicUser"
                    :public-lesson-urls="publicLessonUrls"
                ></component>
            </div>
            <loading-spinner
                v-if="loading"
                :color="color"
            ></loading-spinner>
        </template>
    </div>
</template>

<script>
import Collapse from '../../argon/components/Collapse/Collapse';
import CollapseItem from '../../argon/components/Collapse/CollapseItem';

import ContentCard from '../Common/ContentCard';
import LoadingSpinner from '../Common/LoadingSpinner';
import Lesson from '../CourseComponents/ContentComponents/LessonComponent';
import Module from '../CourseComponents/ContentComponents/ModuleComponent';
import Exercise from '../CourseComponents/ContentComponents/ExerciseComponent';
import Topic from '../CourseComponents/ContentComponents/TopicComponent';

export default {
    name: 'CourseContent',
    components: {
        LoadingSpinner,
        CollapseItem,
        ContentCard,
        Collapse,
        Exercise,
        Lesson,
        Module,
        Topic,
    },
    data() {
        return {
            contents: [],
            loading: false,
            meta: {},
            links: {},
            total: null,
        };
    },
    props: {
        course: {
            type: Object,
            required: true,
        },
        color: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
        publicUser: {
            type: Boolean,
            default: false,
        },
        contentsApiUrl: {
            type: String,
            default: '',
        },
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        active(value) {
            if (value) return this.getContent();
            return null;
        },
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.contents.push(...value.data);
                this.links = value.links;
                this.meta = value.meta;
            },
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        isBottom() {
            if (this.contents.length === this.meta.total) return false;
            return true;
        },
        plan() {
            return this.$store.getters.PLAN;
        },
    },
    methods: {
        getContent(page = false) {
            this.loading = true;

            // Determinar a URL a ser usada
            let url;
            const params = {};

            if (this.publicUser && this.contentsApiUrl) {
                // Usar a URL assinada para acesso público
                url = this.contentsApiUrl;
                // Não adicionar o parâmetro page na URL assinada
                // Se precisarmos de paginação, isso deve ser tratado no backend
            } else {
                // Usar a URL normal para usuários autenticados
                url = `/api/app/plan/${this.plan}/course/${this.course.id}/contents?iso=${this.language.iso}`;
                // Adicionar o parâmetro page apenas para usuários autenticados
                params.page = page || 1;
            }

            window.axios
                .get(url, {
                    params,
                })
                .then((res) => {
                    this.data = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.loading = false;
                });
        },
        scroll() {
            window.addEventListener('scroll', async () => {
                const bottomOfWindow =
                    document.documentElement.scrollTop + window.innerHeight >
                    document.documentElement.offsetHeight - 20;

                if (bottomOfWindow && this.isBottom && !this.loading) {
                    await this.getContent(this.meta.current_page + 1);
                }
            });
        },
    },
    mounted() {
        this.scroll();
    },
};
</script>

<style scoped>

.disabled a {
    color: darkgray !important;
}

.lock {
    height: 22px !important;
    cursor: not-allowed !important;
}

.nch--content-color {
    color: #A9A9A9;
}
</style>
